import { render, staticRenderFns } from "./IntroPage.vue?vue&type=template&id=0c9e5182&scoped=true&"
import script from "./IntroPage.vue?vue&type=script&lang=ts&"
export * from "./IntroPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e5182",
  null
  
)

export default component.exports